import React from 'react';
import Logo from "../../images/logo-name-2025.png";

export const LMSLogo = () => {
  return <img 
    style={{ width: 90, height: 30 }}
    src={Logo} 
    alt="LMS Logo" 
  />;
};